import { Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function Banner() {
  return (
    <Flex
      bgImage={{base:"url('/images/marketplace-category/banner-mobile.png')",md:"url('/images/marketplace-category/banner.png')"}}
      height={{base:"70vw",md:"30vw",xl:"420px"}}
      w="full"
      bgSize={"contain"}
      bgRepeat="no-repeat"
      justifyContent={"center"}
      alignItems="center"
      flexDirection="column"
      color="white"
      backgroundPosition="center"
      
    >
      <Stack alignItems="center"  pos="relative" bottom={{base:5,xl:10}}>
        <Heading fontWeight={"medium"} color="white" fontSize={{base:"24px",xl:"40px"}}>
          Logo Design
        </Heading>
        <Text color="white" fontSize={{base:"13px",xl:"23px"}} fontWeight="semibold" maxW={{base:"80%",md:"none"}} align="center" > 
          Stand Out from the crowd with a logo
        </Text>
      </Stack>
    </Flex>
  );
}
